module.exports = __webpack_public_path__ + "static/img/presysv76.34a0155.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/presysv76.png
// module id = 4WsF
// module chunks = 1